export default __webpack_public_path__ + "static/media/task6post.bb8e3c26.png";